import { useNotificationList } from "../../../../hooks/react-query/useNotificationList";
import { Fragment } from "react";
import { Card, Text } from "@mantine/core";
import { useColors } from "../../../../hooks/colors/useColors";
import { Container } from "../../../UI/container/Container";
import { IconAlertCircle } from "@tabler/icons";

export function Notifications() {
  const { notificationData } = useNotificationList();
  const { colors } = useColors();
  return (
    <Fragment>
      {notificationData && notificationData.length > 0 && (
        <Container noHeight>
          <div className="w-full flex flex-col justify-center items-center gap-8 mb-4">
            {notificationData.map((notification, index) => {
              return (
                <div
                  className="rounded-2xl p-8 flex justify-center items-center max-w-3xl gap-8"
                  key={index}
                  style={{
                    backgroundColor: colors.secondary,
                  }}
                >
                  <div>
                    <IconAlertCircle color="white" size={50} />
                  </div>

                  <Text
                    className="!text-2xl font-bold text-center w-full"
                    color="white"
                  >
                    {notification.message}
                  </Text>
                </div>
              );
            })}
          </div>
        </Container>
      )}
    </Fragment>
  );
}
